import {ReactionSource} from '@/domain/models/Reaction';
import {User} from '@/domain/models/User';

export enum ProfileModal {
  EditProfile = 'editProfile',
  Prompts = 'prompts',
  Languages = 'languages',
  Ethnicities = 'ethnicities',
  Nationalities = 'nationalities',
  Interests = 'interests',
}

export enum FiltersModalView {
  main = 'main',
  languages = 'languages',
  ethnicities = 'ethnicities',
  nationalities = 'nationalities',
  interests = 'interests',
  goals = 'goals',
  locations = 'locations',
  countries = 'countries',
}

export type UserModal = {
  user: User;
  source: ReactionSource;
};

/**
 * web_land_e1 - test first AB test on the landing page /land_e1
 * web_cookie_banner_v2 - test non-blocking cookie banner
 * web_land_vs_onboard - test landing page vs onboarding
 * web_cookie_banner_v3 - rerun test non-blocking cookie banner
 */
export type SIGN_UP_AB_TESTS =
  | 'web_land_e1'
  | 'web_cookie_banner_v2'
  | 'web_land_vs_onboard'
  | 'web_cookie_banner_v3';

export type USER_AB_TESTS = never;
